import { name } from "dayjs/locale/es";
import { AirVent, AlarmClockCheck, Archive, ArrowDownToDot, BadgeDollarSign, Bell, BellDot, BriefcaseBusiness, CalendarClock, CalendarCog, CalendarDays, ChartLine, CircleDollarSign, CircleDot, ClipboardList, DiamondPercent, Drill, FileSignature, FolderKanban, Fuel, Gauge, Handshake, History, Image, KeyRound, LayoutDashboard, LayoutTemplate, Mail, MapPinHouse, MapPinned, MessageSquareHeart, MessageSquareText, MonitorSmartphone, PhoneCall, Receipt, Route, Ruler, Settings2, Shapes, Shield, Table2, Tags, Tangent, Trees, UserPlus, Users, Wallpaper, Warehouse, Waypoints } from "lucide-react";
import * as Path from "Path/index";
// T2/100A73
import { COMPRAS_BODEGAS_V2 } from "config/featureFlags";

export const clientesModules = [
  {
    policy: "customer:view",
    perm: "clientes.clientes",
    name: "Clientes",
    href: Path.pathCustomers.list,
    img: <Users/>,
  },
];

export const configModules = [
  {
    policy: "jobPosition:view",
    perm: "config.catalogos",
    name: "Puestos de trabajo",
    href: Path.pathConfig.job_positions,
    img: <MapPinHouse/>,
    help: "Distribuye a tu equipo en puestos de trabajo Ex: puesto de trabajo barranquilla",
  },
  {
    policy: "roles:view",
    perm: "config.cargos",
    name: "Categorias de usuario",
    href: Path.pathConfig.category_user,
    img: <Shield/>,
    help: "Crea roles para restringir el acceso a modulos en la plataforma",
  },
  {
    policy: "roles:view",
    perm: "config.cargos",
    name: "Cargos y permisos",
    href: Path.pathConfig.cargos,
    img: <KeyRound/>,
    help: "Configura los cargos del sistema nuevo y mira qué cambiaría para cada persona",
  },
  {
    policy: "refrigerante:view",
    perm: "config.catalogos",
    name: "Refigerantes",
    href: Path.pathConfig.refrigerantes,
    img: <Fuel/>,
  },
  {
    policy: "equipmentType:view",
    perm: "config.catalogos",
    name: "Tipo de equipos",
    href: Path.pathConfig.type_equipments,
    img: <AirVent/>,
  },
  {
    policy: "orderType:view",
    perm: "config.catalogos",
    name: "Tipo de ordenes",
    href: Path.pathConfig.type_orders,
    img: <Shapes/>,
  },
  {
    policy: "feedback:admin",
    perm: "config.plataforma", level: "editar",
    name: "Feedback",
    href: Path.pathFeedback,
    img: <MessageSquareHeart/>,
    help: "Configura encuesta que tus clientes responderan al momento de recibir mantenimientos",
  },
  {
    policy: "site:admin",
    perm: "config.plataforma", level: "editar",
    name: "Plataforma",
    href: Path.pathConfigSite,
    img: <Wallpaper/>,
    help: "Configura aspectos generales de tu empresa",
  },
  {
    policy: "site:admin",
    perm: "config.catalogos", level: "editar",
    name: "Causa Raíz",
    href: Path.pathConfig.causa_raiz,
    img: <ArrowDownToDot/>,
  },
  {
    policy: "admin:apk",
    perm: "config.plataforma", level: "editar",
    name: "Gestión APP mobile",
    href: "/apk",
    img: <Archive/>,
  },
  {
    policy: "site:admin",
    perm: "cotizaciones.plantillas", level: "editar",
    name: "Config. cotizaciones",
    href: null,
    submenuKey: "configCotizaciones",
    img: <Settings2/>,
  },
  // T2/100A140: calendario laboral, antes de horas extras (usuario, 2026-10-27). Mismo permiso de
  // configuración de nómina para verlo; cambiarlo es solo de gerencia (lo valida el servidor).
  {
    policy: "user:locations",
    perm: "th.nomina", level: "editar",
    name: "Calendario laboral",
    href: Path.pathCalendarioLaboral,
    img: <CalendarCog/>,
    help: "Días laborales de la empresa en Colombia: días de la semana, festivos de ley y excepciones",
  },
  // T2/100A141, A142: SLA y Configuración de KPI, juntos. Los ve cualquiera con acceso a
  // Configuraciones; cambiarlos es solo de gerencia (lo valida el servidor).
  {
    policy: "",
    name: "SLA",
    href: Path.pathConfigSla,
    img: <CalendarClock/>,
    help: "Plazos de servicio de gerencia; base de los indicadores",
  },
  {
    policy: "",
    name: "Configuración de KPI",
    href: Path.pathConfigKpis,
    img: <Gauge/>,
    help: "Metas de los indicadores por departamento, con base en los SLA",
  },
  {
    policy: "user:locations",
    perm: "th.nomina", level: "editar",
    name: "Configurar horas extras",
    href: "/configuracion/horas-extras",
    img: <AlarmClockCheck/>,
  },
  {
    policy: "site:admin",
    perm: "config.plataforma", level: "editar",
    name: "Notificaciones",
    href: "/configuraciones/notificaciones",
    img: <Bell/>,
  },
  {
    // Modular only (catalog v7): the legacy key is never granted, it just makes
    // the tile count as gated so it opens this tab for whoever holds the action.
    policy: "solicitudes:turnos",
    act: "solicitudes.turnos",
    name: "Turnos de disponibilidad",
    href: "/configuraciones/turnos-disponibilidad",
    img: <PhoneCall/>,
    help: "Quién atiende las emergencias fuera de horario y el horario de atención del chatbot",
  },
  {
    policy: "cambios:admin",
    perm: "config.plataforma", level: "editar",
    name: "Control de cambios",
    href: Path.pathControlCambios,
    img: <ClipboardList/>,
    help: "Triage de reportes de falla, mejoras y nuevas funciones",
  },
  {
    policy: "",
    name: "Mis reportes",
    href: Path.pathMisReportes,
    img: <MessageSquareText/>,
    help: "Consultá el estado de los cambios y mejoras que reportaste",
  },
  {
    policy: "",
    name: "Conectar Outlook",
    href: Path.pathOutlookConnect,
    img: <Mail/>,
    help: "Conectá tu cuenta de Outlook para enviar cotizaciones desde tu propio correo",
  },
  {
    policy: "",
    name: "Mi firma",
    href: Path.pathMiFirma,
    img: <FileSignature/>,
    help: "Subí tu firma para que aparezca en las cotizaciones que generes",
  },
];

export const talentoHumanoModules = [
  {
    policy: "user:view",
    perm: "th.usuarios",
    name: "Usuarios",
    href: Path.pathConfig.user,
    img: <Users/>,
  },
  {
    policy: "user:monitor",
    perm: "th.monitoreo",
    name: "Monitoreo",
    href: Path.pathMonitoringUser,
    img: <MapPinned/>,
  },
  {
    policy: "user:locations",
    perm: "th.monitoreo",
    name: "Informe ubicaciones",
    href: Path.pathMonitoringLocation,
    img: <MapPinHouse/>,
  },
  {
    policy: "user:locations",
    perm: "th.horas",
    name: "Cuadro de horas extras",
    href: "/horas-extras",
    img: <CalendarClock/>,
  },
  {
    policy: "horas-extras:historial",
    perm: "th.horas",
    name: "Historial de horas extras",
    href: "/horas-extras/historial",
    img: <History/>,
  },
  {
    policy: "horas-extras:historial",
    perm: "th.horas",
    name: "Historial por cliente/proyecto",
    href: "/horas-extras/historial/cliente",
    img: <Handshake/>,
  },
];

export const cotizacionesBaseModules = [
  {
    policy: "",
    name: "Cotizaciones",
    href: Path.rutaCotizaciones,
    img: <Handshake/>,
  },
];

export const purchasesModules = [
  {
    policy: "material:view",
    perm: "compras.pricebook",
    name: "Price book",
    href: Path.pathMaterial,
    img: <Tags/>,
  },
  {
    policy: [
      "material-order:create",
      "material-order:update",
      "material-order:operation",
      "material-order:buy",
    ],
    perm: "pedidos.material", level: "editar", act: ["pedidos.aprobar_operacion", "pedidos.aprobar_compra"],
    name: "Solicitudes de material",
    href: Path.pathOrderMaterial,
    img: <BellDot/>,
  },
  {
    policy: "tool-order:view",
    perm: "pedidos.herramientas",
    name: "Asignación de Herramientas",
    href: Path.pathToolOrder,
    img: <BellDot/>,
  },
  {
    policy: "purchase:warehouse",
    perm: "compras.bodegas",
    name: "Bodegas",
    href: Path.pathWarehouse,
    img: <Warehouse/>,
  },
  {
    policy: "tool:view",
    perm: "compras.herramientas",
    name: "Herramientas",
    href: Path.pathTools,
    img: <Drill/>,
  },
  {
    policy: ["spendplan:manage", "spendplan:view"],
    perm: "compras.spendplan",
    name: "SpendPlan",
    href: '/spend-plan',
    img: <DiamondPercent/>,
  },
];

// T2/100A01: Módulos de la pestaña nueva Gestion Compras. Por ahora solo el
// Pricebook, con el mismo permiso del Price book de purchasesModules
// (policy material:view, perm compras.pricebook). purchasesModules no cambia.
// T2/100A96: copia de mosaicos de purchasesModules por nombre (mismo permiso y ruta, sin duplicar).
function comprasLegacyTiles(names) {
  return names.map((n) => purchasesModules.find((m) => m.name === n)).filter(Boolean);
}

// T2/100A108: submódulos en orden de flujo (usuario, 2026-10-27): solicitud → presupuesto → compra
// y precios → bodega → herramientas. Antes: Pricebook, Bodegas, Solicitudes de material,
// Herramientas, Spend plan.
export const gestionComprasModules = [
  // T2/100A96: el Compras original se retiró del menú (components/home/tabs.js). Sus submódulos que
  // aún no tienen versión nueva siguen aquí con su pantalla y permiso de siempre.
  // T2/100A97: Spend plan v2 (antes el mosaico SpendPlan del legado, que sigue abierto desde la
  // pantalla nueva para el detalle por cotización). Antes: ...comprasLegacyTiles(["Solicitudes de material", "SpendPlan"]),
  ...comprasLegacyTiles(["Solicitudes de material"]),
  {
    policy: ["spendplan:manage", "spendplan:view"],
    perm: "compras.spendplan",
    name: "Spend plan",
    href: Path.pathGestionCompras.spendPlan,
    img: <DiamondPercent/>,
  },
  {
    policy: "material:view",
    perm: "compras.pricebook",
    name: "Pricebook",
    href: Path.pathGestionCompras.pricebook,
    img: <Tags/>,
  },
  // T2/100A73: Bodegas v2, mismo permiso que Compras › Bodegas (purchasesModules).
  ...(COMPRAS_BODEGAS_V2
    ? [
        {
          policy: "purchase:warehouse",
          perm: "compras.bodegas",
          // T2/100A217: el mosaico abre Inventario y kardex (la lista de bodegas queda en "Administrar
          // bodegas"). Antes: name: "Bodegas", href: Path.pathGestionCompras.warehouses,
          name: "Inventario y kardex",
          href: Path.pathGestionCompras.inventory,
          img: <Warehouse/>,
        },
      ]
    : []),
  // T2/100A98: Herramientas es submódulo de Compras (usuario, 2026-10-26). La asignación NO va aquí:
  // pasa a Talento Humano (ver abajo).
  // T2/100A99: Herramientas v2 (mismo permiso). Antes: ...comprasLegacyTiles(["Herramientas"]),
  {
    policy: "tool:view",
    perm: "compras.herramientas",
    name: "Herramientas",
    href: Path.pathGestionCompras.tools,
    img: <Drill/>,
  },
  // T2/100A198: Proveedores, al lado de Herramientas (usuario 2026-10-29). Mismo permiso del Price book.
  {
    policy: "material:view",
    perm: "compras.pricebook",
    name: "Proveedores",
    href: Path.pathGestionCompras.suppliers,
    img: <Handshake/>,
  },
];

// T2/100A96: Herramientas sale de Compras (gerencia, 2026-10-26): pestaña propia con las pantallas
// actuales de Herramientas y Asignación, con los mismos permisos.
// T2/100A98: retirado. Herramientas vuelve como submódulo de Compras y la Asignación de Herramientas
// pasa a Talento Humano (usuario, 2026-10-26). Antes:
// export const herramientasModules = comprasLegacyTiles(["Herramientas", "Asignación de Herramientas"]);
// Mismo mosaico (pantalla y permiso pedidos.herramientas / tool-order:view), al final de Talento Humano.
talentoHumanoModules.push(...comprasLegacyTiles(["Asignación de Herramientas"]));

export const project = [
  {
    policy: "project:view",
    perm: "proyectos.proyectos",
    name: "Proyectos",
    href: Path.pathProjects,
    img: <FolderKanban/>,
  },
  {
    policy: "design:view",
    perm: "proyectos.diseno",
    name: "Diseño y consultoría",
    href: Path.pathDesign,
    img: <Tangent/>,
  },
];

export const ventasModules = [
  {
    policy: "crm:view",
    perm: "comercial.crm",
    name: "CRM",
    href: Path.pathCrm.dashboard,
    img: <Handshake/>,
    help: "Pipeline de ventas, seguimiento de leads y gestión comercial",
  },
  {
    policy: "",
    name: "Dashboard cotizaciones",
    href: Path.rutaCotizacionesDashboard,
    img: <Gauge/>,
  },
];

// The Dashboard page is a shell whose tabs each check their own policy
// (Servicios/Dashboard/index.js), so the icon is the union of all of them.
export const DASHBOARD_SERVICIOS_POLICIES = [
  "dashboard-servicios:view",
  "dashboard-servicios:director",
  "dashboard-servicios:director-equipo",
  "dashboard-servicios:ver-todos",
  "dashboard-servicios:control-presupuesto",
  "spendplan:manage",
];

// Global "Solicitudes" tab: one screen for every internal user. The tabs inside
// (Mías / Sin asignar / Todas) and the "Nueva solicitud" button carry their own
// permissions, so the tile itself is open.
export const solicitudesModules = [
  {
    policy: "",
    // T2/100A276: una sola pantalla (merge con test); se conserva el nombre de T2/100A184. Upstream: name: "Solicitudes".
    name: "Solicitudes de casos",
    href: Path.pathSolicitudes,
    img: <ClipboardList/>,
    help: "Tus solicitudes, las que están sin asignar y todas las demás, con seguimiento de ANS. Desde aquí también registras una nueva",
  },
];

export const serviciosModules = [
  {
    policy: DASHBOARD_SERVICIOS_POLICIES,
    perm: "servicios.tablero",
    name: "Dashboard",
    href: Path.pathServicios.dashboard,
    img: <LayoutDashboard/>,
    help: "Vista de tus contratos, órdenes abiertas, cumplimiento de SLA y comisiones",
  },
  {
    policy: "contracts:view",
    perm: "servicios.contratos",
    name: "Contratos",
    href: Path.pathContracts.dashboard,
    img: <FileSignature/>,
  },
  {
    policy: "order:admin",
    perm: "servicios.ordenes",
    name: "Órdenes",
    href: Path.pathOrder.list,
    img: <Table2/>,
  },
  {
    policy: "order:admin",
    perm: "servicios.ordenes",
    name: "Calendario",
    href: Path.pathOrder.calendar,
    img: <CalendarDays/>,
  },
  {
    policy: "roadmap:admin",
    perm: "servicios.rutas", level: "editar",
    name: "Hojas de ruta",
    href: Path.pathRoadmap.list,
    img: <Route/>,
  },
  {
    policy: "maintenancePlan",
    perm: "servicios.planificacion", level: "editar",
    name: "Planifica",
    href: Path.pathMaintenancePlan.list,
    img: <Waypoints/>,
  },
  {
    policy: "maintenanceSchedule",
    perm: "servicios.planificacion", level: "editar",
    name: "Programa",
    href: Path.pathSchedulePlans,
    img: <CalendarCog/>,
  },
  {
    policy: "",
    name: "Histórico de archivos",
    href: "/historico-archivos",
    img: <Image/>,
  },
  {
    policy: "report:maintenance",
    perm: "servicios.informes",
    name: "Informes",
    href: null,
    submenuKey: "informes",
    img: <ChartLine/>,
  },
];

// SLA de emergencias was removed from here in sdd/dashboard-servicios-comisiones
// Slice 3 — consolidated into the Servicios "Dashboard" summary card, not left
// coexisting. SLA de cotización and SLA de correctivos are new dedicated report
// screens (with their own filters/charts) and belong here.
export const submenuInformes = [
  { policy: "report:maintenance", perm: "servicios.informes", name: "Mantenimientos", href: Path.pathReportMaintenances, img: <AirVent/> },
  { policy: "report:box", act: "servicios.caja_menor", name: "Caja menor", href: Path.pathReportMinorBox, img: <CircleDollarSign/> },
  { policy: "report:maintenance", perm: "servicios.informes", name: "Causa raíz", href: Path.rutaReporteCausaRaiz, img: <ArrowDownToDot/> },
  { policy: "report:maintenance", perm: "servicios.informes", name: "Cumplimiento de SLA", href: Path.rutaReporteSlaCotizacion, img: <AlarmClockCheck/> },
  { policy: "report:maintenance", perm: "servicios.informes", name: "Entrega de correctivos", href: Path.rutaReporteEntregaCorrectivos, img: <AlarmClockCheck/> },
  { policy: "", name: "Huella de carbono", href: "/carbon-footprint", img: <Trees/> },
];

export const gerenciaModules = [
  {
    policy: "spendplan:manage",
    perm: "gerencia.ejecutivo",
    name: "Dashboard Ejecutivo",
    href: Path.pathDashboardEjecutivo,
    img: <LayoutDashboard/>,
    help: "KPIs consolidados UN1/UN2/UN3, gross profit, alertas de contratos y top clientes",
  },
  {
    policy: ["siigo:view", "siigo:sync"],
    perm: "gerencia.financiero",
    name: "Financiero",
    href: Path.pathSiigoDashboard,
    img: <BadgeDollarSign/>,
  },
];

export const submenuConfigCotizaciones = [
  { policy: "", name: "Medidas", href: Path.rutaUnidades, img: <Ruler/> },
  { policy: "", name: "Estados", href: Path.rutaCotizacionEstado, img: <CircleDot/> },
  { policy: "", name: "Unidades de negocio", href: Path.rutaCotizacionesUN, img: <BriefcaseBusiness/> },
  { policy: "", name: "Plantillas", href: "/marker-rates-templates", img: <LayoutTemplate/> },
];

export const administrativoModules = [
  {
    policy: "",
    name: "Cola de facturación",
    href: Path.pathBilling,
    img: <Receipt/>,
    help: "Trabajos pendientes de facturar por todas las UNs",
  },
  {
    policy: "vault:view",
    perm: "administrativo.boveda",
    name: "Gestor de contraseñas",
    href: Path.pathBovedas.list,
    img: <KeyRound/>,
    help: "Administra bóvedas de credenciales compartidas por equipo",
  },
  {
    policy: "asset:view",
    perm: "administrativo.activos",
    name: "Activos TI",
    href: Path.pathActivosTi.list,
    img: <MonitorSmartphone/>,
    help: "Inventario de equipos y activos de TI propiedad de JAG",
  },
  {
    policy: ["costos:view", "costos:manage"],
    perm: "administrativo.costos",
    name: "Costos laborales y burden",
    href: Path.pathCostParameters,
    img: <CircleDollarSign/>,
    help: "Parámetros de costeo del año, conceptos del burden y versiones publicadas",
  },
  {
    policy: "",
    name: "Solicitudes administrativas",
    href: Path.pathSolicitudAdmin.list,
    img: <ClipboardList/>,
    help: "Levanta y da seguimiento a solicitudes internas de mantenimiento e infraestructura",
  },
  {
    policy: "",
    name: "Alta de usuario",
    href: Path.pathSolicitudAltaUsuario.list,
    img: <UserPlus/>,
    help: "Solicita la creación de un usuario para una persona recién contratada",
  },
];
